/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ClientProfileStatus = {
    PendingActivation: 1,
    ActionRequired: 2,
    RequiredDataSubmitted: 3,
    FinalApprovalPending: 4,
    Ready: 5,
    Inactive: 6
} as const;
export type ClientProfileStatus = typeof ClientProfileStatus[keyof typeof ClientProfileStatus];

